var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 244,
    viewBox: "0 0 243 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 122.3,
    r: 121.5,
    fill: "#58B0F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_2651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 243,
    height: 244
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 122.3,
    r: 121.5,
    fill: "#58B0F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_2651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.884 213.923H21.6138V113.029C21.6138 105.226 27.8993 98.9404 35.7021 98.9404H207.904C215.707 98.9404 221.993 105.226 221.993 113.029V213.923H221.884Z",
    fill: "#E5EBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.333 205.795H48.1648C41.229 205.795 35.4854 200.159 35.4854 193.115V122.891C35.4854 115.955 41.1207 110.211 48.1648 110.211H195.333C202.269 110.211 208.013 115.846 208.013 122.891V193.115C208.013 200.159 202.377 205.795 195.333 205.795Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1648 205.795C41.229 205.795 35.4854 200.159 35.4854 193.115V122.891C35.4854 115.955 41.1207 110.211 48.1648 110.211H195.333C202.269 110.211 208.013 115.846 208.013 122.891L48.1648 205.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.436 244.266H17.062C9.36758 244.266 3.08203 237.981 3.08203 230.286V228.878C3.08203 221.183 9.36758 214.898 17.062 214.898H226.436C234.13 214.898 240.416 221.183 240.416 228.878V230.286C240.416 238.089 234.13 244.266 226.436 244.266Z",
    fill: "#BDCCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.199 228.77H3.29878C3.1904 228.77 3.08203 228.661 3.08203 228.553V227.794C3.08203 220.1 9.36758 213.814 17.062 213.814H226.436C234.13 213.814 240.416 220.1 240.416 227.794V228.553C240.416 228.661 240.307 228.77 240.199 228.77Z",
    fill: "#E5EBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.659 233.104H91.9468C89.7793 233.104 87.937 231.262 87.937 229.094C87.937 226.927 89.7793 225.085 91.9468 225.085H151.659C153.827 225.085 155.669 226.927 155.669 229.094C155.669 231.262 153.827 233.104 151.659 233.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.174 177.85L144.167 177.844C137.735 172.747 129.83 169.833 121.377 169.651C112.924 169.469 104.837 172.018 98.0405 176.931C95.696 178.621 95.2386 182.034 97.4069 184.182C99.1371 185.896 101.908 186.078 104.001 184.627L104.011 184.62L104.022 184.612C108.915 180.976 115.037 179.07 121.157 179.243C127.29 179.417 133.237 181.5 137.952 185.305L137.975 185.323L137.998 185.34C140.032 186.75 142.805 186.829 144.577 185.088C146.764 183.121 146.477 179.716 144.174 177.85Z",
    fill: "#1F243B",
    stroke: "#1F243B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1635 167.965L83.193 167.998L83.2261 168.027C85.0639 169.645 87.8704 169.964 89.6827 168.202C98.5262 161.03 109.844 157.179 121.341 157.352C133.037 157.705 144.009 161.917 152.499 169.451L152.501 169.453C154.421 171.143 157.213 171.143 159.133 169.453L159.137 169.45C161.286 167.533 161.286 164.316 159.137 162.4L159.135 162.397C148.919 153.362 135.603 148.121 121.735 147.938C107.868 147.578 94.3719 152.278 83.6149 160.946C81.4388 162.673 81.2596 165.87 83.1635 167.965Z",
    fill: "#1F243B",
    stroke: "#1F243B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1283 151.778L69.1423 151.793L69.157 151.808C71.0509 153.684 73.844 153.908 75.9713 152.222L75.9825 152.213L75.9934 152.204C88.7986 141.281 105.342 135.465 122.242 135.818C139.146 136.17 155.153 142.514 167.424 153.789H167.423L167.436 153.8C169.356 155.491 172.148 155.491 174.068 153.8L174.071 153.797C176.219 151.882 176.221 148.669 174.077 146.752C160.08 133.789 141.72 126.407 122.454 126.047L122.454 126.047C103.011 125.687 84.2929 132.346 69.5723 144.764C67.4033 146.493 67.2266 149.685 69.1283 151.778Z",
    fill: "#1F243B",
    stroke: "#1F243B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexIcon);
export default __webpack_public_path__ + "static/media/flex-icon.5ae27b2023689fed6344803ddc31d218.svg";
export { ForwardRef as ReactComponent };